import { Link, Navigate, createFileRoute } from "@tanstack/react-router";
import { BookOpenCheck, Printer, ReceiptText } from "lucide-react";
import onboardingGuideHtml from "../content/global-admin-client-onboarding-operator-guide.html?raw";
import { AdminPageHeader } from "../components/admin/client-operations-shared";
import { useAuth } from "../stores/auth";

export const Route = createFileRoute("/admin/onboarding-guide")({
  component: GlobalAdminOnboardingGuidePage,
});

function GlobalAdminOnboardingGuidePage() {
  const user = useAuth((state) => state.user);
  if (!user) return null;
  if (user.role !== "global_admin") return <Navigate to="/admin/users" replace />;

  return (
    <div className="space-y-5 print:space-y-3">
      <div className="print:hidden">
        <AdminPageHeader
          eyebrow="Global Admin runbook"
          title="Client onboarding operator guide"
          description="A screen-by-screen runbook for creating a client, issuing the first controlled invoice, reconciling payment, configuring access, and reaching a fact-gated live state."
          actions={(
            <>
              <Link
                to="/admin/guide"
                className="inline-flex min-h-8 items-center gap-1.5 rounded-md border border-border bg-bg px-3 py-1.5 text-xs font-medium text-fg transition-colors hover:border-accent/50"
              >
                <ReceiptText size={13} aria-hidden="true" />
                Contracting guide
              </Link>
              <button
                type="button"
                onClick={() => window.print()}
                className="inline-flex min-h-8 items-center gap-1.5 rounded-md border border-border bg-bg px-3 py-1.5 text-xs font-medium text-fg transition-colors hover:border-accent/50"
              >
                <Printer size={13} aria-hidden="true" />
                Print or save PDF
              </button>
            </>
          )}
        />
      </div>

      <header className="hidden border-b border-border pb-3 print:block">
        <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.14em] text-accent">
          <BookOpenCheck size={14} aria-hidden="true" />
          Cascena Global Admin runbook
        </div>
        <h1 className="mt-2 text-2xl font-semibold">Client onboarding operator guide</h1>
        <p className="mt-1 text-sm text-muted">Client creation, controlled first invoice, payment reconciliation, user setup, access activation, and completion.</p>
      </header>

      {/* This is a bundled, first-party HTML fragment. It contains no user or API data. */}
      <div className="ops-admin-guide" dangerouslySetInnerHTML={{ __html: onboardingGuideHtml }} />
    </div>
  );
}
